var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isFunction } from 'lodash';
import React, { PureComponent } from 'react';
import CropArea from './CropArea';
import Screenshot from './Screenshot';
class ScreenCropper extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleCrop = (data) => (boundary) => __awaiter(this, void 0, void 0, function* () {
            const { onTakeScreenshot } = this.props;
            const file = yield Screenshot.cropImage(data, boundary);
            if (isFunction(onTakeScreenshot))
                onTakeScreenshot(file);
        });
    }
    render() {
        const { handleCrop } = this;
        const { open, data } = this.props;
        if (!open)
            return null;
        return (React.createElement("div", null,
            React.createElement(CropArea, { data: data, onCrop: handleCrop(data) })));
    }
}
export default ScreenCropper;
